export const getLegacyAppUrl = (baseOldAppUrl: string, token: string | undefined, url: string) =>
  `${baseOldAppUrl}/${token ? `?token=${token}` : ""}#${url}`;

export const getLegacyLogoutAppUrl = (baseOldAppUrl: string) => `${baseOldAppUrl}/logout.html`;

export const getAppUrl = (baseAppUrl: string, token: string, url: string) =>
  `${baseAppUrl}/?mmc_token=${token}&mmc_redirect=${url}`;
